// Leitura do log de entregas do barramento (Fase 8).
//
// Só LEITURA. As duas tabelas têm RLS de administrador do Inbox, e a de
// entregas não aceita escrita por ninguém pela API — quem grava é o worker,
// com a chave de serviço. Esconder o botão não é autorização; aqui não há nem
// botão de escrever.
//
// ⚠️ A ordenação é por `updated_at`, NUNCA por `created_at`. Um evento vira uma
// entrega por endpoint, e todas nascem no mesmo instante: o desempate fica a
// cargo do banco e muda entre consultas, então a mesma tela mostraria a ordem
// trocada a cada atualização. Descobri isso na pele validando a fase.

import { supabase } from '../../../src/lib/supabase';
import type { EndpointEvento, EntregaEvento, EntregaStatus } from './tipos';

export async function carregarEndpoints(): Promise<EndpointEvento[]> {
  const { data, error } = await supabase
    .from('inbox_event_endpoints')
    .select('id, nome, url, eventos, ativo, created_at')
    .order('created_at', { ascending: true });
  if (error) throw new Error(error.message);
  return (data ?? []) as EndpointEvento[];
}

export interface FiltroEntregas {
  status?: EntregaStatus | 'todos';
  endpointId?: string | 'todos';
  limite?: number;
}

export async function carregarEntregas(f: FiltroEntregas = {}): Promise<EntregaEvento[]> {
  let q = supabase
    .from('inbox_event_deliveries')
    .select(
      'id, endpoint_id, evento, status, tentativas, response_code, failure_reason, payload, created_at, delivered_at, updated_at',
    )
    .order('updated_at', { ascending: false })
    .limit(f.limite ?? 100);

  if (f.status && f.status !== 'todos') q = q.eq('status', f.status);
  if (f.endpointId && f.endpointId !== 'todos') q = q.eq('endpoint_id', f.endpointId);

  const { data, error } = await q;
  if (error) throw new Error(error.message);
  return (data ?? []) as EntregaEvento[];
}
